import { ga } from '../../engine/ga-sidecar'
import { settings } from '../../engine/settings-sidecar'
import { common } from '../../main/common-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { uiFps } from '../../ui/uiFps-sidecar'
import { clickEater } from '../../uiParts/clickEater-sidecar'
import { voyageMissionData } from './missions/voyageMissionData-sidecar'
import { voyageMessages } from './multi/voyageMessages-sidecar'
import { voyageStarmaps } from './starmap/voyageStarmaps-sidecar'

import { voyageBackground } from './voyageBackground-sidecar'
import { voyageCarryableData } from './voyageCarryableData-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageKeyboard } from './voyageKeyboard-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyageParticlesData } from './voyageParticlesData-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageSystemsData } from './voyageSystemsData-sidecar'
import { voyageTileData } from './voyageTileData-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageUiBuyStuff_data } from './voyageUiBuyStuff_data-sidecar'
import { voyageUiNav } from './voyageUiNav-sidecar'
import { voyageUiNav_data } from './voyageUiNav_data-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export function create() {
  ga.init('voyage')

  spritesUtil.setDefaultScale(2)
  settings.create('voyage:settings', 1)

  voyageUiNav_data.registerAll()
  voyageParticlesData.registerAll()
  voyageTileData.registerAll()
  voyageCarryableData.registerAll()
  voyageSystemsData.registerAll()
  voyageUiBuyStuff_data.registerAll()
  voyageMissionData.registerAll()
  voyageMessages.registerAll()

  const soundsJson = common.getPhaserScene().cache.json.get('audioSprite2')
  voyageSounds.load(soundsJson, '/assets/music')

  voyageLayers.create()

  // buttons2.setDefaultFrames(buttons2.defaultFramesBasic)
  // buttons2.setDefaultFont(echoFonts.getData().font6)

  uiFps.create(voyageLayers.getLayers().uiGame)
  uiFps.setOpen(true)
  clickEater.create()
  voyageKeyboard.create()

  voyageTilemap.create()

  voyageStarmaps.setVisible(false)
  voyageStarmaps.create()

  voyageBackground.create()

  //chessWebsockets.create()
  voyageWebsockets.create()

  // Test bodies
  // let b = voyageBodies.create()
  // voyageBodies.moveToXY(b, 100, 100)

  voyageGameManager.goLoading()

  // testing
  // voyageUiNav.setOpen(true)
}
